import { createStore } from 'vuex';
import { merge } from 'lodash';
import SdkStoreConfig from '@nsftx/games-sdk-js/src/store/storeConfig';
import storeConfig from './storeConfig';

export default createStore(merge(storeConfig, SdkStoreConfig));
